import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"h_mobiledata"}/>
}
